export default {
  title: 'Kanta-asiakastabletti',
  headers: {
    customer_frequency: 'Asiakastiheys',
  },
};
